import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.meetings.item');
@Component({
    selector: 'wiz-page-meetings-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.meetings.item/view.scss */
/* src/app/page.meetings.item/view.scss: no such file or directory */`],
})
export class PageMeetingsItemComponent { }

export default PageMeetingsItemComponent;